// extracted by mini-css-extract-plugin
export default {"listWrapper":"List_listWrapper__uBAkE","list":"List_list__-T--w","followButton":"List_followButton__wuf9w"};